import React from 'react'
import { Carousel } from './Carousel'
import { Inicio1 } from './Inicio1'
import { Sliderinfinite } from './Sliderinfinite'
import { Inicio2 } from './Inicio2'

export const Index = () => {
  return (
    <>
    
    <Carousel />

    <Inicio1 />

    <Sliderinfinite />

    <Inicio2 />

    </>
  )
}
